if (!customElements.get("ld-media-carousel")) {
  customElements.define(
    "ld-media-carousel",
    class LdMediaCarousel extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth <= 768;
      }

      initVideoFullScreenPlay() {
        const triggerElements = this.querySelectorAll(".play-video-full");
        triggerElements.forEach((triggerElement) => {
          triggerElement.addEventListener("click", () => {
            const videoUrl = triggerElement.getAttribute("data-url");
            const mobileVideoUrl = triggerElement.getAttribute("data-mobile-url");
            const videoUrlToUse = this.isMobile && mobileVideoUrl ? mobileVideoUrl : videoUrl;
            const video = document.createElement("video");
            if (!videoUrlToUse) {
              return;
            }
            video.src = videoUrlToUse;
            video.controls = true;
            video.muted = true;
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
            video.classList.add("full-video");
            const maskDom = document.createElement("div");
            maskDom.classList.add("full-video-mask", "animate__animated", "animate__fadeIn");
            document.body.appendChild(maskDom);
            document.body.appendChild(video);
            video.play();
            maskDom.addEventListener("click", () => {
              video.pause();
              document.body.removeChild(video);
              document.body.removeChild(maskDom);
            });
          });
        });
      }

      initSwiperDesktop() {
        const wrapper = this.querySelector(".swiper");
        const autoplayDelay = this.getAttribute("data-autoplay-delay") || 5000;
        const slidesSize = wrapper.querySelectorAll(".swiper-slide").length;
        if (slidesSize <= 1) {
          return;
        }
        new Swiper(wrapper, {
          slidesPerView: 1,
          threshold: 30,
          // simulateTouch: this.isMobile,
          parallax: !this.isMobile,
          loop: true,
          autoplay: {
            delay: autoplayDelay,
            disableOnInteraction: false,
          },
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
            clickable: true,
          },
          navigation: {
            nextEl: wrapper.querySelector(".swiper-btn-next"),
            prevEl: wrapper.querySelector(".swiper-btn-prev"),
          },
        });
      }

      connectedCallback() {
        this.initSwiperDesktop();
        this.initVideoFullScreenPlay();
      }
    }
  );
}
